/**
 * Formats a date for display in chat message bubbles.
 *
 * Examples:
 *   Today → "Today · 14:35"
 *   Yesterday → "Yesterday · 09:12"
 *   This week (Mon–Sun) → "Monday · 11:00"
 *   This year → "Jan 31 · 16:45"
 *   Previous years → "Dec 13, '25 · 08:30"
 */
export function formatMessageDate(date: Date): string {
  const now = new Date();
  const time = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(yesterdayStart.getDate() - 1);

  if (date >= todayStart) {
    return `Today · ${time}`;
  }

  if (date >= yesterdayStart) {
    return `Yesterday · ${time}`;
  }

  // This week: within the last 7 days
  const weekAgo = new Date(todayStart);
  weekAgo.setDate(weekAgo.getDate() - 6);
  if (date >= weekAgo) {
    const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
    return `${dayName} · ${time}`;
  }

  // This year
  if (date.getFullYear() === now.getFullYear()) {
    const monthDay = date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    return `${monthDay} · ${time}`;
  }

  // Previous years
  const monthDay = date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  const year = date.getFullYear().toString().slice(-2);
  return `${monthDay}, '${year} · ${time}`;
}
